import React, { useState } from 'react'
import styled from '@emotion/styled'

import { colors } from 'Constants'

import { Flex, Grid } from 'lese'

const ContainerStyled = styled(Flex)`
  padding-bottom: ${({ paddingBottom }) => paddingBottom && `50px`};
`

const Container = ({ children, ...props }) => {
  const [activeTab, setActiveTab] = useState(0)

  const childrenArr = React.Children.toArray(children)

  const tabs = React.cloneElement(childrenArr[0], { setActiveTab, activeTab })
  return (
    <ContainerStyled column {...props}>
      {tabs}
      {childrenArr[activeTab + 1]}
    </ContainerStyled>
  )
}

const TabsStyled = styled(Grid)`
  grid-auto-flow: ${({ autoWidth }) => (autoWidth ? 'column' : 'row')};
  grid-template-columns: ${({ autoWidth, children }) =>
    autoWidth
      ? `repeat(${children.length}, 1fr`
      : `repeat(5, ${
          Math.round(children.length / 5) > 1
            ? Math.round(children.length / 5)
            : 1
        }fr)`};
`
TabsStyled.defaultProps = {
  xAlign: 'stretch'
}

const Tabs = ({ setActiveTab, activeTab, children, ...props }) => (
  <TabsStyled {...props}>
    {children.map((child, tabNumber) =>
      React.cloneElement(child, {
        onClick: () => setActiveTab(tabNumber),
        active: tabNumber === activeTab
      })
    )}
  </TabsStyled>
)
const TabStyled = styled(Flex)`
  padding: ${({ padding }) => (padding ? padding : `30px 16px`)};
  font-size: ${({ fontSize }) => fontSize && `14px`};
  cursor: pointer;

  > h3 {
    color: ${colors.textLight};
  }

  > span {
    font-size: ${({ numFontSize }) => (numFontSize ? numFontSize : `2.5em`)};
    ${({ active }) => active && `font-weight: bold`}
  }

  border-top: 1px solid ${colors.borderColor};
  border-left: 1px solid ${colors.borderColor};
  border-bottom: 1px solid ${colors.borderColor};
  border-right: 1px solid ${colors.borderColor};

  ${({ active }) => active && `border-top: 2px solid ${colors.primary}`}
  ${({ active }) =>
    !active &&
    `
  border-bottom: 2px solid ${colors.borderColor};
  background-color: ${colors.background600};
  `};
`

const Tab = ({ header, value, children, ...props }) => (
  <TabStyled column separation="16px" {...props}>
    <h3>{header}</h3>
    <span>{value?.toLocaleString()}</span>
    {children}
  </TabStyled>
)

const Content = styled(Flex)`
  padding: 16px;
  border-bottom: 2px solid ${colors.borderColor};
  border-left: 2px solid ${colors.borderColor};
  border-right: 2px solid ${colors.borderColor};
`
Content.defaultProps = { column: true, separation: '16px' }

export default { Container, Tabs, Tab, Content }
